<template>
    <div class="splide-carousel-wrapper pa-2 d-flex flex-column">
        <!-- Carrossel Principal -->
        <div ref="mainSlider" class="splide flex-grow-1" style="min-height: 300px;">
            <div class="splide__track">
                <ul class="splide__list">
                    <li
                        v-for="(img, i) in photos"
                        :key="`main-${i}`"
                        class="splide__slide"
                        style="display: flex; justify-content: center; align-items: center; background-color: #000;"
                    >
                        <img
                            :src="img.urlremoto" 
                            :alt="img.order"
                            :class="$vuetify.breakpoint.xsOnly ? 'carousel-main-image-mobile' : 'carousel-main-image'"
                        />
                    </li>
                </ul>
            </div>
        </div>
        

        <div :class="$vuetify.breakpoint.mdAndDown ? 'mt-3' : 'mt-4'"></div>

        <!-- Miniaturas -->
        <div
            ref="thumbSlider"
            class="splide thumbs"
            style="flex-shrink: 0;"
        >
            <div class="splide__track">
                <ul class="splide__list">
                    <li
                        v-for="(img, i) in photos"
                        :key="`thumb-${i}`"
                        class="splide__slide"
                    >
                        <img
                            :src="img.urlremoto" 
                            :alt="img.order"
                            style="width: 150px; height: 113px; object-fit: cover; border-radius: 4px;"
                        />
                    </li>
                </ul>
            </div>
        </div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';

export default {
    name: 'SplideCarousel',

    props: {
        photos: {
            type: Array, // Adicione o tipo
            required: false, // Corrigido: "required" em vez de "require"
            default: () => [] // Adicione um valor padrão para arrays
        },
    },
    
    data() {
        return { 
            main: null,
            thumbs: null,
            window: null,
        };
    },

    mounted() {
        this.initSplide();
    },

    beforeDestroy() {
        if (this.main) this.main.destroy();
        if (this.thumbs) this.thumbs.destroy();
    },

    methods: {
        initSplide() {
            // Ajuste de altura com base na altura da janela (viewport)
            let mainHeight = '600px'; // padrão desktop

            if (window.innerHeight <= 800) {
                // Para tablets e mobiles comuns (ex: iPad, Galaxy Tab, etc.)
                mainHeight = '505px';
            }
            
            if (window.innerHeight <= 740) {
                // Para tablets e mobiles comuns (ex: iPad, Galaxy Tab, etc.)
                mainHeight = '420px';
            }
            if (window.innerHeight <= 600) {
                // Para mobiles ou tablets em modo retrato apertado
                mainHeight = '360px';
            }

            this.window = window.innerHeight;

            //console.log(mainHeight + ' ' + window.innerHeight);

            const main = new Splide(this.$refs.mainSlider, {
                type: 'fade',
                //height: this.$vuetify.breakpoint.mdAndDown ? '400px' : '600px', // ajuste para mobile/tablet
                height: mainHeight,
                cover: false,
                pagination: false,
                arrows: true,
            });

            const thumbs = new Splide(this.$refs.thumbSlider, {
                fixedWidth: 150,
                fixedHeight: 117,
                isNavigation: true,
                gap: 8,
                rewind: false,
                pagination: false,
                arrows: true,
                focus: 'left',
            });

            main.sync(thumbs);
            main.mount();
            thumbs.mount();

            this.main = main;
            this.thumbs = thumbs;

            // Força resize após montagem
            this.$nextTick(() => {
                setTimeout(() => {
                try {
                    main?.Components?.Resize?.resize?.();
                    thumbs?.Components?.Resize?.resize?.();
                } catch (e) {
                    console.warn('Resize falhou (pode ser normal em alguns casos)', e);
                }
                }, 100);
            });
        },
    },
};
</script>

<style>
@import '@splidejs/splide/dist/css/splide.min.css';

.splide-carousel-wrapper {
  height: 90vh;
  margin: 0 auto;
  background: #000
}

.thumbs .splide__slide.is-active {
  opacity: 1;
  transform: scale(1.05);
  transition: all 0.3s ease;
}

.carousel-main-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}

.carousel-main-image-mobile {
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}

.thumbs {
  position: relative;
  padding: 0 80px; /* espaço para as setas fora do track */
}

.thumbs .splide__arrow {
  pointer-events: all;
  background-color: #ffffff; /* fundo claro translúcido */
  color: white; /* ícone branco */
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 20;
  transition: background-color 0.2s ease;
}

.thumbs .splide__arrow:hover {
  background-color: rgb(255, 255, 255);
}



</style>
